<template>
  <span
    class="brief-form__tooltip"
    :data-uk-tooltip="`title: ${title}; pos: top-left`"
    @click.prevent.stop
  >
    <img data-uk-svg src="@/assets/images/tooltip.svg" alt="plik" />
  </span>
</template>
<script>
export default {
  name: 'tooltip',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped lang="scss">
.brief-form {
  &__tooltip {
    width: rem(16px);
    height: rem(16px);
    transform: translateY(rem(-7px));
    display: inline-block;
    margin-left: rem(5px);

    svg {
      width: rem(16px);
      height: rem(16px);
    }
  }
}
</style>
<style lang="scss">
body {
  .uk-tooltip {
    border-radius: 0.188rem;
    background-color: $white;
    padding: rem(16px 20px);
    color: $purple;
    border: rem(1px) solid $purple;
    font-size: 0.75rem;
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0.038rem;
    line-height: 1rem;

    @include media-min($md) {
      width: 16.813rem !important;
      max-width: unset;
    }
  }
}
</style>
